import React from 'react'
// libs
import { destroy } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
// components
import { AddIcon, RiskViewLabel, SectionHeader } from 'components/PageComponents/Risks/Register/views'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentUser } from 'hooks/useCurrentUser'
// constants
import { Forms, Modals } from 'constants/index'
// context
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
// types
import { IRiskView } from 'types/graphql'
// store
import { riskViewsSelector } from 'store/reducers/riskViews'

const RiskViewsList: React.FC = () => {
  const dispatch = useDispatch()

  const { riskView, selectRiskView } = React.useContext(RiskRegisterContext)

  const riskViews = useSelector(riskViewsSelector)

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  const { showModal } = useShowModal({ modalType: Modals.RISK_VIEW_CREATE_MODAL })

  const showRiskViewDrawer = () => showModal()

  const onRiskViewClick = (view: IRiskView) => () => {
    if (riskView?.id !== view.id) {
      selectRiskView(view)

      localStorage.clear()
      localStorage.setItem('riskView', view.id)

      dispatch(destroy(Forms.RISK_VIEW_FILTER_FORM))
    }
  }

  return (
    <>
      <SectionHeader>
        <h2>Views</h2>
        {manageRiskTemplates && <AddIcon data-testid='add-risk-view' onClick={showRiskViewDrawer} />}
      </SectionHeader>

      {riskViews.map((view) => (
        <RiskViewLabel
          key={view.id}
          onClick={onRiskViewClick(view)}
          data-testid='risk-view-list-item'
          $isActive={view.id === riskView?.id}>
          {view.name}
        </RiskViewLabel>
      ))}
    </>
  )
}

export default RiskViewsList
